import { PlusIcon, CloudArrowUpIcon } from '@heroicons/react/24/solid';
import { OfflineButton } from '../atoms/OfflineFormComponents.jsx';

const TrainingSessionsHeader = ({ canModify, handleCreate, handleImport }) => {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
      <div>
        <h1 className="text-xl font-bold text-gray-900 md:text-2xl">Training Sessions</h1>
        <p className="mt-1 text-sm text-gray-500">
          Create unscheduled training sessions with crews. Schedule them later in the Planner.
        </p>
      </div>

      {canModify && (
        <div className="mt-4 flex flex-col gap-2 sm:mt-0 sm:flex-row">
          <OfflineButton
            variant="secondary"
            featureType="import"
            onClick={handleImport}
            className="order-2 w-full sm:order-1 sm:w-auto"
          >
            <CloudArrowUpIcon className="mr-2 h-5 w-5" />
            <span className="hidden sm:inline">Import Sessions</span>
            <span className="sm:hidden">Import</span>
          </OfflineButton>
          <OfflineButton
            variant="primary"
            featureType="create"
            onClick={handleCreate}
            className="order-1 w-full sm:order-2 sm:w-auto"
          >
            <PlusIcon className="mr-2 h-5 w-5" />
            <span className="hidden sm:inline">Create Session</span>
            <span className="sm:hidden">Create</span>
          </OfflineButton>
        </div>
      )}
    </div>
  );
};

export default TrainingSessionsHeader;
